<template>
    <img src="res/vr.png" :class="picposcls" class="iconsize" @click="onClick">
</template>

<script>
import { gotoLink } from "@/d";
export default {
  data() {
    return {

    };
  },

  props:{
    picposcls:String,
  },

  mounted(){
    // window.console.log(this.picposcls);
  },

  methods: {
    onClick(){
      gotoLink('https://720yun.com/t/68vkuq77dql#scene_id=41418402');
    },
  },

  components: {}
};
</script>

<style lang="scss">

</style>
